import ShapeDataStream from "./ShapeDataStream";
import MapObjectShape from "../element/MapObjectShape";

export default class FromOMBShapeDataStream extends ShapeDataStream {
    constructor(id, allElements, mapObjectStatusDataStream, forceAllVisible = false) {
        super(id, forceAllVisible);
        this.statusCache = {}

        this.shapes = [];
        for (var element of allElements) {
            if (element instanceof MapObjectShape) {
                this.shapes.push(element);
            }
        }

        if (mapObjectStatusDataStream) {
            mapObjectStatusDataStream.observe().subscribe((data) => {
                if (data) {
                    const mapObjectStatusTemplates = data.mapObjectStatusTemplates;
                    const mapObjectStatusList = data.mapObjectStatusList;
    
                    if (mapObjectStatusTemplates && mapObjectStatusList) {
                        for (var shape of this.shapes) {
                            const mapObjectStatus = this._findMapObjectStatusForShape(shape.getId(), mapObjectStatusList);
                            if (mapObjectStatus) {
                                // cache the parent's status for eventual children
                                if (shape.children) {
                                  for (const child of shape.children){
                                    this.statusCache[child.getId()] = mapObjectStatus 
                                  }
                                }
                                const normalStyle = shape.normalStyle;
                                if (normalStyle) {
                                    const mapObjectStatusTemplate = this._findMapObjectStatusTemplate(mapObjectStatus.mapObjectStatusTemplateId, mapObjectStatusTemplates);
                                    if (mapObjectStatusTemplate) {
                                        const statusVisibleStyle = JSON.parse(JSON.stringify(normalStyle));
                                        statusVisibleStyle.strokeColor = mapObjectStatusTemplate.color;
                                        shape.statusVisibleStyle = statusVisibleStyle;
                                    }
                                }
                            } else {
                                shape.statusVisibleStyle = null;
                            }
                        }
                    }
    
                    this.initialize(this.shapes);
                }
            });
        }
    }

    toJSON() {
        const json = super.toJSON();
        json.type = "shape";
        json.elements = [];

        var topLatitude = -90.0;
        var leftLongitude = 180.0;
        var bottomLatitude = 90.0;
        var rightLongitude = -180.0;

        for (var shape of this.shapes) {
            json.elements.push({
                id: shape.id,
                name: shape.name,
                geoPoints: shape.getGeoPoints(),
                topLeftBound: shape.topLeftBound,
                bottomRightBound: shape.bottomRightBound
            });

            if (shape.topLeftBound && shape.bottomRightBound) {
                topLatitude = Math.max(topLatitude, shape.topLeftBound.latitude);
                leftLongitude = Math.min(leftLongitude, shape.topLeftBound.longitude);
                bottomLatitude = Math.min(bottomLatitude, shape.bottomRightBound.latitude);
                rightLongitude = Math.max(rightLongitude, shape.bottomRightBound.longitude);
            }
        }

        json.topLeftBound = { latitude: topLatitude, longitude: leftLongitude };
        json.bottomRightBound = { latitude: bottomLatitude, longitude: rightLongitude };

        return json;
    }

    _findMapObjectStatusForShape(shapeId, mapObjectStatusList) {
        for (var mapObjectStatus of mapObjectStatusList) {
            if (mapObjectStatus.mapObjectId === shapeId) {
                return mapObjectStatus;
            }
            // Use the parent's status
            if (shapeId in this.statusCache) {
              return this.statusCache[shapeId]
            }
        }

        return null;
    }

    _findMapObjectStatusTemplate(templateId, mapObjectStatusTemplates) {
        for (var mapObjectStatusTemplate of mapObjectStatusTemplates) {
            if (mapObjectStatusTemplate.id === templateId) {
                return mapObjectStatusTemplate;
            }
        }
        return null;
    }
}
